import path from "path";
import {
  ASSETS_EQUIPMENT,
  ASSETS_MODULE,
  BUDGET_CATEGORIES,
  BUDGET_MODULE,
  DEPARTMENTS,
  FIREDRILL_MODULE,
  FIRERISK_PROCESSES,
  FIRERISK_SUB_PROCESSES,
  FS_DASHBOARD_MODULE,
  INCIDENT_DASHBOARD,
  INCIDENT_LIST,
  INCIDENT_REPORTS,
  INCIDENTS_MODULE,
  LECCAL_CONTRACT_TYPES,
  LAWS_REGULATIONS_MODULE,
  MONITORING_MODULE,
  POLICY_MODULE,
  POLICY_TAGS,
  PREMISES_MODULE,
  REGION_MODULE,
  RISKASSES_MODULE,
  ROLES_MODULE,
  SAFETYAUDIT_MODULE,
  TASK__MODULE,
  TRAINING_MODULE,
  USER_MODULE,
  WASHROOM_CHECKLIST_CATEGORY,
  WASHROOM_DASHBOARD,
  WASHROOM_MANAGEMENT,
  WASHROOM_CHECKLISTS,
  WASHROOM_AUDITS,
  WASHROOM_REPORTS_ANALYTICS,
  WASHROOM_ISSUES_REPORTS,
  EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
  EQUIPMENT_MANAGEMENT_DOCUMENTATION_AND_HISTORY,
  EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
  EQUIPMENT_MANAGEMENT_REPORT_AND_ANALYTICS,
  EQUIPMENT_MANAGEMENT_TASKS,
  EQUIPMENT_MANAGEMENT_INCIDENT,
  HAZARDOUS_MATERIALS_INVENTORY,
  HAZARDOUS_MATERIALS_SAFETY_COMPLIANCE,
  HAZARDOUS_MATERIALS_STORAGE_HANDLING,
  HAZARDOUS_MATERIALS_TRACKING_MOVEMENT,
  HAZARDOUS_MATERIALS_INCIDENT_AND_SPILL,
  HAZARDOUS_MATERIALS_INSPECTION_COMPLIANCE,
  HAZARDOUS_MATERIALS_DISPOSAL_MANAGEMENT,
  HAZARDOUS_MATERIALS_SEARCH_REPORTING,
  HAZARDOUS_MATERIALS_POLICIES_MANUALS,
  HAZARDOUS_MATERIALS_TRAINING_EVALUATION,
  EQUIPMENT_MANAGEMENT_TRAINING_EVALUATION,
  LAWS_REGULATIONS_DASHBOARD,
  LAWS_REGULATIONS_POLICIES,
  LAWS_REGULATIONS_AUDITS,
  LAWS_REGULATIONS_TASKS,
  LAWS_REGULATIONS_PREMISES_INFO,
  LAWS_REGULATIONS_STAFF_MANAGEMENT,
  WASHROOM_TYPES_LIST,
  HAZARDOUS_MATERIALS_TESTING_DRILLS,
  HAZARDOUS_MATERIALS_WASTE,
  HAZARDOUS_MATERIALS_AUDITS,
  EQUIPMENT_MANAGEMENT_BUDGETING,
  EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
  EXTERNAL_EMERGENCY_PREPAREDNESS_RISK_ASSESSMENT,
  UTILITY_SYSTEMS_DASHBOARD,
  PREVENTIVE_PREDICTIVE_MAINTENANCE,
  PROJECT_PLANNING_APPROVALS,
  INFECTION_CONTROL_SAFETY_PLANNING,
  MONITORING_IOT_INTEGRATION,
  SAFETY_FACILITY_ROUNDS_DASHBOARD,
  SECURITY_DASHBOARD,
  SECURITY_ACCESS_ZONES,
  SECURITY_ACCESS_ASSIGNMENTS,
  SECURITY_VISITOR_MANAGEMENT,
  SECURITY_CAMERAS,
  SECURITY_INCIDENTS,
  SECURITY_PARKING,
  SECURITY_COMPLIANCE_AUDIT,
  EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
  EXTERNAL_EMERGENCY_PREPAREDNESS_TESTING_DRILLS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_EVALUATION,
  EXTERNAL_EMERGENCY_PREPAREDNESS_EXTERNAL_AGENCIES_COORDINATION,
  UTILITY_SYSTEMS_ASSET_INVENTORY_TRACKING,
  UTILITY_ASSET_TYPE_LIST,
  UTILITY_SYSTEMS_COMPLIANCE_SAFETY,
  UTILITY_SYSTEMS_SPACE_MANAGEMENT,
  UTILITY_SYSTEMS_CONTRACTOR_VENDOR_MANAGEMENT,
  UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION,
  EXTERNAL_EMERGENCY_PREPAREDNESS_RESOURCE_FOR_READINESS,
  EMERGENCY_CATEGORY,
  EMERGENCY_SUB_CATEGORY,
  EQUIPMENT_CATEGORY,
  EQUIPMENT_SUB_CATEGORY,
  SAFETY_FACILITY_ROUNDS_PLANNING,
  SAFETY_FACILITY_ROUNDS_CHECKLISTS,
  SAFETY_FACILITY_ROUNDS_ISSUES,
  SAFETY_ROUNDS_TYPES,
  COMPLIANCE_AUDIT_DOCUMENTATION,
  BUDGETING_COST_CONTROL,
  SAFETY_FACILITY_ROUNDS_NOTIFICATIONS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_ICS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS,
  EQUIPMENT_MANAGEMENT_MODULE,
} from "./constants/modules";
import { matchPath } from "react-router-dom";

export const dashboardNavs = {
  default: [
    { title: "Dashboard", path: "/dashboard", subModuleKey: "dashboard" },
    // { title: "Premises", path: "/premises" },
    // { title: "Tasks", path: "/tasks" },
    // { title: "Policies And Manuals", path: "/policies-manuals" },
    // { title: "Risk Assessment & Mitigation Plan", path: "/risk-assessment" },
    // { title: "Budgeting For Fire Safety Systems", path: "/budgeting" },
    // {
    //   title: "Fire Safety Equipment Inventory & Maintenance",
    //   path: "/safety-equipment",
    // },

    // {
    //   title: "Staff Training & Evaluation",
    //   path: "/trainings",
    //   children: [
    //     { title: "Training Dashboard", path: "/trainings/training-dashboard" },
    //     { title: "Upcoming Sessions", path: "/trainings/upcoming-sessions" },
    //     { title: "Past Evaluations", path: "/trainings/past-evaluations" },
    //   ],
    // },
    // { title: "Testing/ Drills", path: "" },

    // { title: "Staff Training & Evaluation", path: "/trainings" },
    // { title: "Testing/ Drills", path: "/fire-drill" },

    // { title: "Monitoring", path: "" },
    // { title: "Fire Safety Audits", path: "/fires-safety-audits" },
    // { title: "Complaint/Ticketing/Incidents", path: "/fire-safety-incident" },
    // { title: "Data Monitoring & Analysis", path: "" },
  ],
  "fire-system": [
    {
      title: "Overview",
      note: "daily use, outside the cycle",
      children: [
        {
          title: "Dashboard",
          path: "/fire-system/dashboard",
          subModuleKey: FS_DASHBOARD_MODULE,
        },
        // { title: "Premises", path: "/premises", subModuleKey: "premises" },
        { title: "Tasks", path: "/tasks", subModuleKey: TASK__MODULE },
      ],
    },
    {
      title: "Plan",
      children: [
        {
          title: "Policies And Manuals",
          path: "/policies-manuals",
          subModuleKey: POLICY_MODULE,
          matchPaths: ["/policies-manuals", "/folder"],
        },
        {
          title: "Risk Assessment & Mitigation Plan",
          path: "/risk-assessment",
          subModuleKey: RISKASSES_MODULE,
        },
        {
          title: "Budgeting For Fire Safety Systems",
          path: "/budgeting",
          subModuleKey: BUDGET_MODULE,
        },
      ],
    },
    {
      title: "Implement",
      note: "commission & operate",
      children: [
        {
          title: "Fire Safety Equipment Inventory & Maintenance",
          path: "/safety-equipment",
          subModuleKey: ASSETS_MODULE,
          matchPaths: [
            "/safety-equipment",
            "/safety-equipment/fire-extinguisher",
            "/safety-equipment/fire-door",
            "/safety-equipment/smoke-detector",
            "/safety-equipment/heat-detector",
            "/safety-equipment/sprinkler",
            "/safety-equipment/control-panel",
            "/safety-equipment/hose",
          ],
        },
        {
          title: "Staff Training & Evaluation",
          // path: "/trainings",
          children: [
            {
              title: "Training Dashboard",
              path: "/trainings/training-dashboard",
              subModuleKey: TRAINING_MODULE,
            },
            {
              title: "Upcoming Sessions",
              path: "/trainings/upcoming-sessions",
              subModuleKey: TRAINING_MODULE,
            },
            {
              title: "Past Evaluations",
              path: "/trainings/past-evaluations",
              subModuleKey: TRAINING_MODULE,
            },
          ],
        },
        // { title: "Staff Training & Evaluation", path: "/trainings", subModuleKey: TRAINING_MODULE },
      ],
    },
    {
      title: "Verify",
      note: "prove it works",
      children: [
        {
          title: "Testing/ Drills",
          path: "/fire-drill",
          subModuleKey: FIREDRILL_MODULE,
        },
        {
          title: "Monitoring",
          path: "/fire-system/monitoring",
          subModuleKey: MONITORING_MODULE,
          matchPaths: ["/fire-system/monitoring"],
        },
      ],
    },
    {
      title: "Improve",
      note: "find gaps, act",
      children: [
        {
          title: "Fire Safety Audits",
          path: "/fires-safety-audits",
          subModuleKey: SAFETYAUDIT_MODULE,
        },
        {
          title: "Complaint/ Ticketing/ Incidents",
          path: "/fire-safety-incident",
          subModuleKey: INCIDENTS_MODULE,
        },
        /*     {
          title: "Data Monitoring & Analysis",
          path: "",
          subModuleKey: DATA_ANALYSIS_MODULE,
        }, */
      ],
    },
  ],
  "fire-safety-incident-admin": [
    {
      title: "Incident Dashboard",
      path: "/incident-dashboard",
      subModuleKey: INCIDENT_DASHBOARD, ///INCIDENT_DASHBOARD
    },
    {
      title: "Incidents",
      path: "/incidents",
      subModuleKey: INCIDENT_LIST, //INCIDENT_LIST
    },
    {
      title: "Report",
      path: "/report",
      subModuleKey: INCIDENT_REPORTS, //INCIDENT_REPORTS
    },
  ],
  "master-dashboard": [
    {
      title: "Regions",
      path: "/regions",
      subModuleKey: REGION_MODULE,
      matchPaths: [
        "/regions",
        "/regions/update-region",
        "/regions/edit-region",
        "/regions/view-region",
      ],
    },
    {
      title: "Premises",
      path: "/premises",
      subModuleKey: PREMISES_MODULE,
      matchPaths: [
        "/premises",
        "/update-premises",
        "/edit-premises",
        "/view-premises",
      ],
    },
    {
      title: "Role And User Management",
      // path: "/",
      children: [
        {
          title: "Role Management",
          path: "/role-management/roles",
          subModuleKey: ROLES_MODULE,
        },
        {
          title: "User Management",
          path: "/user-management/roles",
          subModuleKey: USER_MODULE,
        },
      ],
    },
    {
      title: "Master Data Management",
      // path: "/",
      children: [
        {
          title: "Departments",
          path: "/departments",
          subModuleKey: DEPARTMENTS,
        },
        {
          title: "Policy Tags",
          path: "/policy-tags",
          subModuleKey: POLICY_TAGS,
        },
        {
          title: "Fire Risk Processes",
          path: "/firerisk-processes",
          subModuleKey: FIRERISK_PROCESSES,
        },
        // {
        //   title: "Suppliers Details",
        //   path: "/suppliers",
        //   subModuleKey: SUPPLIERS,
        // },
        {
          title: "Fire Risk Sub-Processes",
          path: "/firerisk-sub-processes",
          subModuleKey: FIRERISK_SUB_PROCESSES,
        },
        {
          title: "Budget Categories",
          path: "/budget-categories",
          subModuleKey: BUDGET_CATEGORIES,
        },
        {
          title: "Legal Contract Types",
          path: "/legal-contract-types",
          subModuleKey: LECCAL_CONTRACT_TYPES,
        },
        {
          title: "Asset Equipment Category",
          path: "/asset-equipment-category",
          subModuleKey: ASSETS_EQUIPMENT,
          matchPaths: [
            "/asset-equipment-category",
            "/asset-equipment-category/create",
            "/asset-equipment-category/edit",
            "/asset-equipment-category/view",
          ],
        },
        {
          title: "Asset Equipment Sub-Category",
          path: "/asset-equipment-subcategory",
          subModuleKey: ASSETS_EQUIPMENT,
        },
        {
          title: "Washroom Checklist Category",
          path: "/washroom-checklist-category",
          subModuleKey: WASHROOM_CHECKLIST_CATEGORY,
        },
        {
          title: "Washroom Types List",
          path: "/washroom-types-list",
          subModuleKey: WASHROOM_TYPES_LIST,
        },
        {
          title: "Equipment Category",
          path: "/equipment-category",
          subModuleKey: EQUIPMENT_CATEGORY,
        },
        {
          title: "Equipment Sub-Category",
          path: "/equipment-subcategory",
          subModuleKey: EQUIPMENT_SUB_CATEGORY,
        },
        {
          title: "Emergency Category",
          path: "/emergency-category",
          subModuleKey: EMERGENCY_CATEGORY,
        },
        {
          title: "Emergency Sub-Category",
          path: "/emergency-subcategory",
          subModuleKey: EMERGENCY_SUB_CATEGORY,
        },
        {
          title: "Manufacturer List",
          path: "/manufacturers-list",
          subModuleKey: "ManufacturerList",
        },
        {
          title: "Vendor/ Supplier Master",
          path: "/vendor-list",
          subModuleKey: "VendorList",
        },
        {
          title: "Location Master",
          path: "/location-master",
          subModuleKey: "LocationMaster",
        },
        {
          title: "Maintenance Type List",
          path: "/maintenancetype-list",
          subModuleKey: "MaintenanceTypes",
        },
        {
          title: "Unit of Measure List",
          path: "/unit-of-measure-list",
          subModuleKey: "UnitOfMeasureList",
        },
        {
          title: "Incident Severity Levels",
          path: "/incident-severity-levels",
          subModuleKey: "IncidentSeverityLevels",
        },
        {
          title: "Hazard Material Category",
          path: "/hazard-material-category",
          subModuleKey: "HazardMaterialCategory",
        },
        {
          title: "Disposal Methods List",
          path: "/disposal-methods-list",
          subModuleKey: "DisposalMethodsList",
        },
        {
          title: "Compliance Types",
          path: "/compliance-types",
          subModuleKey: "ComplianceType",
        },
        {
          title: "Utility Asset Type List",
          path: "/utility-asset-type-list",
          subModuleKey: UTILITY_ASSET_TYPE_LIST,
        },
        {
          title: "Round Types",
          path: "/round-types",
          subModuleKey: SAFETY_ROUNDS_TYPES,
        },
        {
          title: "Equipment Management",
          path: "/master-data/equipment-management",
          subModuleKey: EQUIPMENT_MANAGEMENT_MODULE,
        },
      ],
    },
  ],
  "washroom-management": [
    {
      title: "Dashboard",
      path: "/washroom-management/dashboard",
      subModuleKey: WASHROOM_DASHBOARD,
    },
    {
      title: "Washroom Management",
      path: "/washroom-management/washrooms",
      subModuleKey: WASHROOM_MANAGEMENT,
    },
    {
      title: "Checklists",
      path: "/washroom-management/checklists",
      subModuleKey: WASHROOM_CHECKLISTS,
      matchPaths: [
        "/washroom-management/checklists",
        "/washroom-management/checklists/create",
        "/washroom-management/checklists/edit",
        "/washroom-management/checklists/view",
      ],
    },
    {
      title: "Audits",
      path: "/washroom-management/audits",
      subModuleKey: WASHROOM_AUDITS,
      matchPaths: [
        "/washroom-management/audits",
        "/washroom-management/audits/view",
        "/washroom-management/audits/history",
      ],
    },
    {
      title: "Reports & Analytics",
      path: "/washroom-management/reports",
      subModuleKey: WASHROOM_REPORTS_ANALYTICS,
    },
    {
      title: "Complaint/ Issues/ Incidents",
      path: "/washroom-management/issues-reports",
      subModuleKey: WASHROOM_ISSUES_REPORTS,
    },
  ],
  "laws-regulations": [
    {
      title: "Dashboard",
      path: "/laws-regulations",
      subModuleKey: LAWS_REGULATIONS_DASHBOARD,
    },
    {
      title: "Policies & Manuals",
      path: "/laws-regulations-policies",
      subModuleKey: LAWS_REGULATIONS_POLICIES,
      matchPaths: ["/laws-regulations-policies", "/law-folder"],
    },
    {
      title: "Audits",
      path: "/laws-regulations-audit",
      subModuleKey: LAWS_REGULATIONS_AUDITS,
    },
    {
      title: "Tasks",
      path: "/laws-regulations-tasks",
      subModuleKey: LAWS_REGULATIONS_TASKS,
    },
    {
      title: "Independent Entity",
      path: "/facility-information",
      subModuleKey: LAWS_REGULATIONS_PREMISES_INFO,
      matchPaths: ["/facility-information", "/premises-information-view"],
    },
    {
      title: "Independent Entity Staff Management",
      path: "/staff-management",
      subModuleKey: LAWS_REGULATIONS_STAFF_MANAGEMENT,
    },
  ],
  "equipment-management": [
    {
      title: "Tasks",
      path: "/equipment-management/equipmentTasks",
      subModuleKey: EQUIPMENT_MANAGEMENT_TASKS,
    },
    {
      title: "Equipment Inventory & Registration",
      path: "/equipment-management/equipment-inventory-registration",
      subModuleKey: EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
    },
    {
      title: "RFID Demo Console",
      path: "/equipment-management/rfid-demo-console",
      subModuleKey: EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
      matchPaths: ["/equipment-management/rfid-demo-console"],
    },
    {
      title: "Maintenance Scheduling & Tracking",
      path: "/equipment-management/maintenance-scheduling-and-tracking",
      subModuleKey: EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
    },
    {
      title: "Documentation & History",
      path: "/equipment-management/documentation-and-history",
      subModuleKey: EQUIPMENT_MANAGEMENT_DOCUMENTATION_AND_HISTORY,
    },
    {
      title: "Report & Analytics",
      path: "/equipment-management/report-and-analytics",
      subModuleKey: EQUIPMENT_MANAGEMENT_REPORT_AND_ANALYTICS,
    },
    {
      title: "Incident",
      path: "/equipment-management/incident",
      subModuleKey: EQUIPMENT_MANAGEMENT_INCIDENT,
    },
    {
      title: "Budgeting",
      path: "/equipment-management/budgeting",
      subModuleKey: EQUIPMENT_MANAGEMENT_BUDGETING,
    },
    {
      title: "Staff Training & Evaluation",
      children: [
        {
          title: "Training Dashboard",
          path: "/equipment-management/staff-training-evaluation/dashboard",
          subModuleKey: EQUIPMENT_MANAGEMENT_TRAINING_EVALUATION,
          matchPaths: [
            "/equipment-management/staff-training-evaluation/dashboard",
            "/equipment-management/staff-training-evaluation/trainings/create",
            "/equipment-management/staff-training-evaluation/trainings",
          ],
        },
        {
          title: "Upcoming Sessions",
          path: "/equipment-management/staff-training-evaluation/upcoming-sessions",
          subModuleKey: EQUIPMENT_MANAGEMENT_TRAINING_EVALUATION,
          matchPaths: [
            "/equipment-management/staff-training-evaluation/upcoming-sessions",
            "/equipment-management/staff-training-evaluation/upcoming-sessions/",
            "/equipment-management/staff-training-evaluation/upcoming-sessions/:id",
          ],
        },
        {
          title: "Past Evaluations",
          path: "/equipment-management/staff-training-evaluation/past-evaluations",
          subModuleKey: EQUIPMENT_MANAGEMENT_TRAINING_EVALUATION,
          matchPaths: [
            "/equipment-management/staff-training-evaluation/past-evaluations",
            "/equipment-management/staff-training-evaluation/past-evaluations/:id",
          ],
        },
      ],
    },
  ],
  "hazardous-materials": [
    {
      title: "Material Inventory Management",
      path: "/hazardous-materials/inventory",
      subModuleKey: HAZARDOUS_MATERIALS_INVENTORY,
    },
    {
      title: "Safety & Compliance Information",
      path: "/hazardous-materials/safety-compliance-info",
      subModuleKey: HAZARDOUS_MATERIALS_SAFETY_COMPLIANCE,
    },
    {
      title: "Storage & Handling Records",
      path: "/hazardous-materials/storage-records",
      subModuleKey: HAZARDOUS_MATERIALS_STORAGE_HANDLING,
    },
    {
      title: "Tracking & Movement Logs",
      path: "/hazardous-materials/tracking-logs",
      subModuleKey: HAZARDOUS_MATERIALS_TRACKING_MOVEMENT,
    },
    {
      title: "Incident & Spill Reporting",
      path: "/hazardous-materials/spill-reporting",
      subModuleKey: HAZARDOUS_MATERIALS_INCIDENT_AND_SPILL,
    },
    {
      title: "Inspection & Compliance Checks",
      path: "/hazardous-materials/inspection-checks",
      subModuleKey: HAZARDOUS_MATERIALS_INSPECTION_COMPLIANCE,
    },
    {
      title: "Disposal Management",
      path: "/hazardous-materials/disposal-management",
      subModuleKey: HAZARDOUS_MATERIALS_DISPOSAL_MANAGEMENT,
    },
    {
      title: "Search & Reporting",
      path: "/hazardous-materials/search-reporting",
      subModuleKey: HAZARDOUS_MATERIALS_SEARCH_REPORTING,
    },
    {
      title: "Hazardous Waste",
      path: "/hazardous-materials/waste-tracking",
      subModuleKey: HAZARDOUS_MATERIALS_WASTE,
    },
    {
      title: "Policies & Manuals",
      path: "/hazardous-materials/policies-manuals",
      subModuleKey: HAZARDOUS_MATERIALS_POLICIES_MANUALS,
      matchPaths: [
        "/hazardous-materials/policies-manuals",
        "/hazardous-materials/policies-manuals/folder",
      ],
    },
    {
      title: "Risk Assessment & Mitigation Plan",
      path: "/hazardous-materials/risk-assessment",
      subModuleKey: RISKASSES_MODULE,
    },
    {
      title: "Hazardous  Audits",
      path: "/hazardous-materials/audits/perform-audits",
      subModuleKey: HAZARDOUS_MATERIALS_AUDITS,
    },
    {
      title: "Staff Training & Evaluation",
      children: [
        {
          title: "Training Dashboard",
          path: "/hazardous-materials/staff-training-evaluation/dashboard",
          subModuleKey: HAZARDOUS_MATERIALS_TRAINING_EVALUATION,
          matchPaths: [
            "/hazardous-materials/staff-training-evaluation/dashboard",
            "/hazardous-materials/staff-training-evaluation/trainings/create",
            "/hazardous-materials/staff-training-evaluation/trainings",
          ],
        },
        {
          title: "Upcoming Sessions",
          path: "/hazardous-materials/staff-training-evaluation/upcoming-sessions",
          subModuleKey: HAZARDOUS_MATERIALS_TRAINING_EVALUATION,
          matchPaths: [
            "/hazardous-materials/staff-training-evaluation/upcoming-sessions",
            "/hazardous-materials/staff-training-evaluation/upcoming-sessions/",
            "/hazardous-materials/staff-training-evaluation/upcoming-sessions/:id",
          ],
        },
        {
          title: "Past Evaluations",
          path: "/hazardous-materials/staff-training-evaluation/past-evaluations",
          subModuleKey: HAZARDOUS_MATERIALS_TRAINING_EVALUATION,
          matchPaths: [
            "/hazardous-materials/staff-training-evaluation/past-evaluations",
            "/hazardous-materials/staff-training-evaluation/past-evaluations/:id",
          ],
        },
      ],
    },
    {
      title: "Testing/ Drills",
      path: "/hazardous-materials/testing-drills",
      subModuleKey: HAZARDOUS_MATERIALS_TESTING_DRILLS,
    },
  ],
  "utility-systems-module": [
    {
      title: "Dashboard",
      path: "/utility-systems/dashboard",
      subModuleKey: UTILITY_SYSTEMS_DASHBOARD,
    },
    {
      title: "Asset Inventory & Tracking",
      path: "/utility-systems/asset-inventory-tracking",
      subModuleKey: UTILITY_SYSTEMS_ASSET_INVENTORY_TRACKING,
    },
    {
      title: "Preventive & Predictive Maintenance",
      path: "/utility-systems/maintenance/schedules",
      subModuleKey: PREVENTIVE_PREDICTIVE_MAINTENANCE,
    },
    {
      title: "Project Planning & Approvals",
      path: "/utility-systems/project-planning",
      subModuleKey: PROJECT_PLANNING_APPROVALS,
    },
    {
      title: "Budgeting & Cost Control",
      path: "/utility-systems/budgeting-cost-control",
      subModuleKey: BUDGETING_COST_CONTROL,
    },
    {
      title: "Infection Control & Safety Planning",
      path: "/utility-systems/infection-control",
      subModuleKey: INFECTION_CONTROL_SAFETY_PLANNING,
    },
    {
      title: "Compliance & Safety",
      path: "/utility-systems/compliance-safety",
      subModuleKey: UTILITY_SYSTEMS_COMPLIANCE_SAFETY,
    },
    {
      title: "Space Management",
      path: "/utility-systems/space-management",
      subModuleKey: UTILITY_SYSTEMS_SPACE_MANAGEMENT,
    },
    {
      title: "Contractor & Vendor Management",
      path: "/utility-systems/contractor-vendor-management",
      subModuleKey: UTILITY_SYSTEMS_CONTRACTOR_VENDOR_MANAGEMENT,
    },
    {
      title: "Design & Documentation Integration",
      path: "/utility-systems/design-documentation-integration",
      subModuleKey: UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION,
    },
    {
      title: "Monitoring & IoT Integration",
      path: "/utility-systems/iot/dashboard",
      subModuleKey: MONITORING_IOT_INTEGRATION,
    },
  ],
  "external-emergency-preparedness-module": [
    {
      title: "Dashboard",
      path: "/external-emergency-preparedness/dashboard",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    },
    {
      title: "Emergency Response Plans",
      path: "/external-emergency-preparedness/emergency-response-plans",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS,
    },
    {
      title: "Business Continuity & Recovery",
      path: "/external-emergency-preparedness/bcp-plans",
      subModuleKey:
        EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    },
    {
      title: "Testing/ Drills",
      path: "/external-emergency-preparedness/testing-drills",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_TESTING_DRILLS,
    },
    {
      title: "Risk Assessment & Mitigation Plan",
      path: "/external-emergency-preparedness/risk-assessment",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_RISK_ASSESSMENT,
    },
    {
      title: "Incident Command System",
      path: "/external-emergency-preparedness/ics",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_ICS,
    },
    {
      title: "Incidents",
      path: "/external-emergency-preparedness/incidents",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS,
    },
    {
      title: "Staff Training & Evaluation",
      children: [
        {
          title: "Training Dashboard",
          path: "/external-emergency-preparedness/staff-training-evaluation/dashboard",
          subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_EVALUATION,
          matchPaths: [
            "/external-emergency-preparedness/staff-training-evaluation/dashboard",
            "/external-emergency-preparedness/staff-training-evaluation/trainings/create",
            "/external-emergency-preparedness/staff-training-evaluation/trainings",
          ],
        },
        {
          title: "Upcoming Sessions",
          path: "/external-emergency-preparedness/staff-training-evaluation/upcoming-sessions",
          subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_EVALUATION,
          matchPaths: [
            "/external-emergency-preparedness/staff-training-evaluation/upcoming-sessions",
            "/external-emergency-preparedness/staff-training-evaluation/upcoming-sessions/",
            "/external-emergency-preparedness/staff-training-evaluation/upcoming-sessions/:id",
          ],
        },
        {
          title: "Past Evaluations",
          path: "/external-emergency-preparedness/staff-training-evaluation/past-evaluations",
          subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_EVALUATION,
          matchPaths: [
            "/external-emergency-preparedness/staff-training-evaluation/past-evaluations",
            "/external-emergency-preparedness/staff-training-evaluation/past-evaluations/:id",
          ],
        },
      ],
    },
    {
      title: "Coordination of External Agencies",
      path: "/external-emergency-preparedness/external-agencies-coordination",
      subModuleKey:
        EXTERNAL_EMERGENCY_PREPAREDNESS_EXTERNAL_AGENCIES_COORDINATION,
    },
    {
      title: "Communication & Notification System",
      path: "/external-emergency-preparedness/notifications",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
      matchPaths: [
        "/external-emergency-preparedness/notifications",
        "/external-emergency-preparedness/send-notification",
        "/external-emergency-preparedness/notifications/:id",
      ],
    },
    {
      title: "Emergency Response Execution",
      path: "/external-emergency-preparedness/erp-executions",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
      matchPaths: [
        "/external-emergency-preparedness/erp-executions",
        "/external-emergency-preparedness/trigger-erp",
        "/external-emergency-preparedness/erp-executions/:id",
      ],
    },
    {
      title: "Monitoring & Reporting",
      path: "/external-emergency-preparedness/monitoring",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    },
    {
      title: "Resources & Readiness",
      path: "/external-emergency-preparedness/resource-for-readiness",
      subModuleKey: EXTERNAL_EMERGENCY_PREPAREDNESS_RESOURCE_FOR_READINESS,
    },
  ],
  "safety-facility-rounds-module": [
    {
      title: "Dashboard",
      path: "/safety-facility-rounds/dashboard",
      subModuleKey: SAFETY_FACILITY_ROUNDS_DASHBOARD,
    },
    {
      title: "Round Planning & Scheduling",
      path: "/safety-facility-rounds/round-planning",
      subModuleKey: SAFETY_FACILITY_ROUNDS_PLANNING,
    },
    {
      title: "Compliance Audit & Documentation",
      path: "/safety-facility-rounds/compliance-audit-documentation",
      subModuleKey: COMPLIANCE_AUDIT_DOCUMENTATION,
    },
    {
      title: "Checklists & Inspection Criteria",
      path: "/safety-facility-rounds/checklists",
      subModuleKey: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    },
    {
      title: "Round Issues",
      path: "/safety-facility-rounds/issues",
      subModuleKey: SAFETY_FACILITY_ROUNDS_ISSUES,
      matchPaths: [
        "/safety-facility-rounds/issues",
        "/safety-facility-rounds/issues/create",
        "/safety-facility-rounds/issues/:id",
        "/safety-facility-rounds/issues/edit/:id",
      ],
    },
    {
      title: "Round Notifications",
      path: "/safety-facility-rounds/notifications",
      subModuleKey: SAFETY_FACILITY_ROUNDS_NOTIFICATIONS,
    },
  ],
  "security-module": [
    {
      title: "Dashboard",
      path: "/security/dashboard",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Access Control & Authorization",
      children: [
        {
          title: "Overview",
          path: "/security/access-control",
          subModuleKey: SECURITY_ACCESS_ZONES,
        },
        {
          title: "Access Zones",
          path: "/security/access-control/zones",
          subModuleKey: SECURITY_ACCESS_ZONES,
        },
        {
          title: "Access Assignments",
          path: "/security/access-control/assignments",
          subModuleKey: SECURITY_ACCESS_ASSIGNMENTS,
        },
        {
          title: "Access Logs",
          path: "/security/access-control/logs",
          subModuleKey: SECURITY_ACCESS_ZONES,
        },
      ],
    },
    {
      title: "Surveillance & Monitoring",
      children: [
        {
          title: "Overview",
          path: "/security/surveillance",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Camera master",
          path: "/security/surveillance/cameras",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Live & playback",
          path: "/security/surveillance/live",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Camera health",
          path: "/security/surveillance/health",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Motion alerts",
          path: "/security/surveillance/motion-alerts",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Crowd heatmap",
          path: "/security/surveillance/heatmap",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "VMS integration",
          path: "/security/surveillance/vms",
          subModuleKey: SECURITY_CAMERAS,
        },
        {
          title: "Incident video clips",
          path: "/security/surveillance/incident-clips",
          subModuleKey: SECURITY_CAMERAS,
        },
      ],
    },
    {
      title: "Incident & Emergency Management",
      path: "/security/incidents",
      subModuleKey: SECURITY_INCIDENTS,
    },
    {
      title: "Visitor & Vendor Management",
      path: "/security/visitor-management",
      subModuleKey: SECURITY_VISITOR_MANAGEMENT,
    },
    {
      title: "Asset & Equipment Security",
      path: "/security/asset-security",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Staff Safety & Workforce Security",
      path: "/security/staff-safety",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Parking & Perimeter Security",
      path: "/security/parking",
      subModuleKey: SECURITY_PARKING,
    },
    {
      title: "Cyber-Physical Security Integration",
      path: "/security/cyber-physical",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Compliance, Audit & Reporting",
      path: "/security/compliance-audit-reporting",
      subModuleKey: SECURITY_COMPLIANCE_AUDIT,
    },
    {
      title: "AI & Predictive Security",
      path: "/security/ai-predictive",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Security Integration & Interoperability",
      path: "/security/integrations",
      subModuleKey: SECURITY_DASHBOARD,
    },
    {
      title: "Security Command Center",
      path: "/security/command-center",
      subModuleKey: SECURITY_DASHBOARD,
    },
  ],
};
